import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  button: {
    width: 100,
    textWrap: "wrap",
  },
  buttonContained: {
    color: "#fff !important",
    borderRadius: "0px !important",
    backgroundColor: "#0288d1 !important",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
  },
  buttonOutlined: {
    backgroundColor: "transparent !important",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    color: "#0288d1 !important",
    border: "1px solid rgba(2, 136, 209, 0.5) !important",
  },
}));
